import { useLocation } from 'react-router-dom';
import HomeIcon from './HomeIcon';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();
  const location = useLocation();
  let currentPage;
  if (location.pathname === '/solutions') currentPage = 'solutions';
  else if (location.pathname === '/stores') currentPage = 'collectionCenter';
  else if (location.pathname === '/supply-prices') currentPage = 'materials';
  else if (location.pathname === '/partnerships') currentPage = 'materials';
  else if (location.pathname === '/contact-us') currentPage = 'contactUs';
  else if (location.pathname === '/privacy-policy')
    currentPage = 'privacyPolicy';
  return (
    <section className="hero-section">
      <h1>
        <HomeIcon /> / {t(`breadcrumb.${currentPage}.title`)}
      </h1>
      <p>{t(`breadcrumb.${currentPage}.description`)}</p>
    </section>
  );
}
